@if (src()) {
  <img [alt]="'COMMON.IMAGES.AVATAR' | translate" [src]="src()" />
} @else {
  <button mat-icon-button>
    <mat-icon>account_circle</mat-icon>
  </button>
}
